import { hasPermission } from '@/components/public'
export default (Vue) => {
  Vue.directive('permission', {
    // 元素插入到节点后执行
    inserted: function (el, binding) {
      // console.log('directive ' + binding.value)
      if (binding.value) {
        if (hasPermission(binding.value)) {
        } else {
          el.parentNode && el.parentNode.removeChild(el)
        }
      }
    },
    // 挂载,第一次插入到dom 执行
    bind: function (el, binding) {
      // console.log('directive bind ' + binding.value)
    },
    // 更新
    update(el, binding) {
      // console.log('directive update ' + binding.value)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/directives.js